export default __webpack_public_path__ + "static/media/progettoEPC.1a63cac2.png";